<template>
	<div>
		<kendo-grid loading="true"
			:id="gridId"
			:data-source="dataSource"
			:excel="excelPages"
			:columns="columns"
			:height="height" 
			:groupable="groupable"
			:selectable="selectable"
			:filterable="filterable"
			:resizable="resizable"
			:no-records="noRecords"
			:reorderable="reorderable"
			:column-menu="columnMenu"
			:sortable="sortable"
			:pageable="pageable"
			:toolbar="toolbar"
			:editable="editable"
			:detailInit="childGridInitialize"
			:dataBound="dataBound"
			:save="calculatedColumn"
			:scrollable="scrollable"
			:excelExport="excelExport"
			>
		</kendo-grid>
	</div>
</template>

<script>
import apiUtil from "@/services/apiUtil.js";
import funcUtil from "@/services/funcUtil.js";
import _ from "lodash";
import { mapGetters, mapState, mapActions } from 'vuex';



const defaultConfig = {
	gridId: "kendoGrid",
	autoBind: false,
	pageSize: 100,
	actionsColumnWidth:90,
	height: 0,
	groupable : false,
	selectable : false,
	filterable : true,
	resizable : true,
	noRecords : true,
	reorderable : true,
	columnMenu : true,
	toolbar: false,
	editable: false,
	scrollable:true,
	excelPages: { allPages:true },
	sortable : { mode: "multiple", allowUnsort: true, showIndexes: true},
	pageable : { input: false, numeric: true, pageSizes: [10, 20, 50, 100, 200, 500]}
};

export default {
	name: "BaseGrid",
	props: { 
		mode: {
			type: String,
			default: "readonly",
			validator: (value) => ["readonly", "incell", "inline", "editform","actionedit"].indexOf(value) !== -1
		},
		config: {
			type: Object,
			default: defaultConfig
		},
		query: Object,
		colorizeColumn: Boolean,
		colorizeInputColumns: Array,
		data: Array,
		dropdownOptions: Object,
		childGridInitialize: {
			type:Function,
			default: null
		},
		excelExport:{
			type:Function,
			default: null
		},
		group:{},
		aggregate:{}
	},
	mixins: [ apiUtil, funcUtil ],
	data: function() {
		return this.getKendoConfig();
	},
	computed: {
		...mapGetters("getModule",["withFilter"]),
		columns: function() {
			// console.log(this.config.list + " columns recomputed", this.config)
			return this.getKendoColumns()
		},
		dataSource: function() {
			return this.getKendoDataSource()
		}
	},
	mounted: function() {
		const self = this;
        // console.log(this.config.list + " mounted", this.config)
        $("body").on("click", ".edit-button-"+self.gridId, function(e) {
            var btn = $(this);
            e.preventDefault();
            if (btn.hasClass("fa-pencil-square-o")) {
                var grid = btn.closest("[data-role=grid]").data("kendoGrid");
                var dataItem = grid.dataItem(btn.closest("tr"));
                self.$emit("EditItem", e, dataItem);
            }
        }); 

        $("body").on("click", ".delete-button-"+self.gridId, function(e) {
            var btn = $(this);
            e.preventDefault();
            if (btn.hasClass("fa-trash")) {
                self.$emit("DeleteItem", e);
            }
        });	

		$("body").on("click", ".erase-button-"+self.gridId, function(e) {
            var btn = $(this);
            e.preventDefault();
            if (btn.hasClass("fa-eraser-img")) {
                self.$emit("CorrectItem", e);
            }
        });	

		$("body").on("click", ".pdf-button-"+self.gridId, function(e) {
            var btn = $(this);
            e.preventDefault();
            if (btn.hasClass("fa-lg")) {
                self.$emit("StatementDownload", e);
            }
        });	

		$("body").on("click", ".fa-paperclip", function(e) {
            var btn = $(this);
            e.preventDefault();
            if (btn.hasClass("document-button")) {
                var grid = btn.closest("[data-role=grid]").data("kendoGrid");
                var dataItem = grid.dataItem(btn.closest("tr"));
                self.$emit("AttachItem", e, dataItem);
            }
        });

		$("body").on("click", ".fa-info-circle", function(e) {
            var btn = $(this);
            e.preventDefault();
            if (btn.hasClass("info-button")) {
                var grid = btn.closest("[data-role=grid]").data("kendoGrid");
                var dataItem = grid.dataItem(btn.closest("tr"));
                self.$emit("InfoItem", e, dataItem);
            }
        });
	},
	methods: {		
		...mapActions("getModule",["getDataWithQuery","GetItems"]),
		detailInit(e){
			// alert("detail Init");  
			this.$emit("detailInit", e)
		},
		calculatedColumn(e){
			const self = this;
			
			if(self.config.grid.save){
				this.$emit("calculatedColumn", e)
			}
			// else{
			// 	e.preventDefault();
			// }
		},
		getKendoConfig() {
			// this function takes in the defaultConfig object as default values for template binding
			// each config could be overwritten by passing the "config" prop from the instance's parent
			let self = this, data = {};

			Object.keys(defaultConfig).forEach( (key) => {
				data[key] = (typeof self.config.grid === "object" && typeof self.config.grid[key] !== "undefined") ? self.config.grid[key] : defaultConfig[key];
			});

			switch (self.mode) {
				case "readonly":
					data['editable'] = false;
					break;
				case "incell":
					// data['editable'] = true;	
					data['editable'] = {confirmation: false};	// editable is true and confirmation is false				
					data['toolbar'] = ['create']; //['create', 'save', 'cancel']
					break;
				case "editform":
					data['editable'] = false;
					break;
				case "inline":
					// data['editable'] = true;
					data['editable'] = {confirmation: false};	// editable is true and confirmation is false
					break;
				case "actionedit":
					data['editable'] = "inline";
					// data['editable'] = {mode:"inline", confirmation: false};
					break;	
			};

			return data;
		},

		getKendoColumns() {
			// this function takes in the config JS file and generate Kendo columns on the fly
			// it also adds the checkbox column and/or actions (edit and/or delete) column based on the prop
			// TODO: bind the click events
			let self = this, columns = [];
			// custom columns
			Object.entries(self.config.columns).forEach( (item) => {

				if (item[1].column !== false) {
					let column = {};
					column.field = item[0];
					column.title = item[1].title;
					column.width = item[1].width;
					column.type  = item[1].type;
					column.editorType =(item[1].editorType) ? item[1].editorType : ''
					// if (typeof item[1].editor!=='undefined') {
					// 	column.editor= fileTypeDropDownEditor, 
					// 	column.template= "#= FileType.Name #"
					// }

					if (typeof item[1].template !== 'undefined') {
						column.template = item[1].template;
					} else if (item[1].type === 'date') {
						column.template = '#=(' + column.field + '!=null)? kendo.toString(new Date(' + column.field + '), \'MM/dd/yyyy\') :\'\' #';
					} else if (item[1].type === 'boolean') {
						column.template = '#=(' + column.field + '==true)? "Yes" : "No" #';
 					} else if (item[1].type === 'excelimage') {
						var fileName = item[1].title.toString();
						fileName = fileName.replace(/&/g, "amp---").replace(/>/g, "gt---").replace(/</g, "lt---").replace(/"/g, "quot---");
						column.command = { className:"ey-excel", text: '' , name: fileName , click: (e) => { self.$emit('getFileDownload', e) } };//self.getFileDownload };
					}else if (item[1].type === 'summaryimage') {
						var fileName = item[1].title.toString();
						fileName = fileName.replace(/&/g, "amp---").replace(/>/g, "gt---").replace(/</g, "lt---").replace(/"/g, "quot---");												
						column.command = { className:"ey-summary", text: '',name: fileName, click: (e) => { self.$emit('getFileDownload', e) }};
						// column.template = '<a href="#:Summary#" download><div class="ey-summary"></div></a>';
					}else if (item[1].dropdown == true) {
						column.field = item[0];
						column.editor= this.DropDownEditor
						column.template = '#=('+column.field +') #' //this.getDropDownOptions(item[1].source)
					}else if (item[1].type === 'dropdownactions') {
						column.field = item[0];
						//column.editor= this.DropDownEditor
						column.template = this.dropdownActionMenu(item[1].key,item[1].menu)
						
					};

					if (item[1].type === 'string') {
						column.filterable = { multi: true, search: true };
					} else if (item[1].type === 'date') {
						column.filterable = { ui: 'datepicker' };
					};

					if(item[1].editorType && item[1].editorType =='percentEditor'){
						column.field = item[0];
						column.editor= this.percentEditor
					}

					if (typeof item[1].hidden !== 'undefined') {column.hidden = item[1].hidden;}
					if (typeof item[1].locked !== 'undefined') {column.locked = item[1].locked;}
					if (typeof item[1].menu !== 'undefined') {column.menu = item[1].menu;}
					if (typeof item[1].format !== 'undefined') {column.format = item[1].format;}
					if (typeof item[1].groupable !== 'undefined') {column.groupable = item[1].groupable;}
					if (typeof item[1].filterable !== 'undefined') {column.filterable = item[1].filterable;}
					if (typeof item[1].sortable !== 'undefined') {column.sortable = item[1].sortable;}
					if (typeof item[1].editable !== 'undefined') {column.editable = item[1].editable;}
					if (typeof item[1].minResizableWidth !== 'undefined') {column.minResizableWidth = item[1].minResizableWidth;}
					if (typeof item[1].headerTemplate !== 'undefined') {column.headerTemplate = item[1].headerTemplate;}
					if (typeof item[1].footerTemplate !== 'undefined') {column.footerTemplate = item[1].footerTemplate;}
					if (typeof item[1].groupHeaderTemplate !== 'undefined') {column.groupHeaderTemplate = item[1].groupHeaderTemplate;}
					if (typeof item[1].groupFooterTemplate !== 'undefined') {column.groupFooterTemplate = item[1].groupFooterTemplate;}

					columns.push(column);
				};
			});

			//Configurable Action Column Width
			let actionsColumnWidth = defaultConfig.actionsColumnWidth;
			
			if (self.config.grid.actionsColumnWidth) {
				actionsColumnWidth=self.config.grid.actionsColumnWidth
			}

			// action columns
			switch (self.mode) {

				case "readonly":
					break;

				case "incell":
				case "inline":
						// columns.push({ 
					// 	command: { name: "destroy", className: "gridbutton" },
					// 	title: "Actions",
					// 	width: 40						
					// });
					// break;					
					if (self.config.grid.edit || self.config.grid.delete || self.config.grid.document || self.config.grid.info || self.config.grid.pdfdoc) {
						let commands = [];
						if (self.config.grid.edit) {commands.push({
							name: "Edit",
							template: '<i class="edit-button-'+self.gridId +' fa fa-pencil-square-o fa-lg" title="Click to edit item" style="cursor: pointer"></i>',
							//click: (e) => { self.$emit("EditItem", e) }
						});}
						if (self.config.grid.delete) {commands.push({
							name: "Delete",
							template:'<i class="delete-button-'+self.gridId +' fa fa-trash fa-lg" title="Click to delete item" style="cursor: pointer"></i>',
							//click: (e) => { self.$emit("DeleteItem", e) }
						});}
						if (self.config.grid.document) {commands.push({
							name: "Attachment",
							template:'<i class="document-button fa fa-paperclip fa-lg" title="Click to show attachments" style="cursor: pointer"></i>',
						});}
						if (self.config.grid.info) {commands.push({
							name: "Information",
							template:'<i class="info-button-'+self.gridId +' fa fa-info-circle fa-lg" title="Click to show informatiom" style="cursor: pointer"></i>',
						});}
						if (self.config.grid.pdfdoc) {commands.push({
							name: "pdfdoc",
							template:'<i class="pdf-button-'+self.gridId +' fa fa-file-pdf-o fa-lg" title="Click to Download Report" style="cursor: pointer"></i>',
						});}

						if (self.config.grid.document) {
							columns.unshift({ command: commands, title: "Actions", width: actionsColumnWidth });
						}else if(self.config.grid.pdfdoc){
							columns.push({ command: commands, title: "Statement Download", width: actionsColumnWidth });
						} 
						else {
							// han 2/15: move actions to front
							// columns.push({ command: commands, title: "Actions", width: actionsColumnWidth });
							columns.unshift({ command: commands, title: "Actions", width: actionsColumnWidth });
						}
						
						
					};
					break;

				case "editform":
					if (self.config.grid.edit || self.config.grid.delete || self.config.grid.document || self.config.grid.info || self.config.grid.pdfdoc|| self.config.grid.erase) {
						let commands = [];
						if (self.config.grid.edit) {commands.push({
							name: "Edit",
							template: '<i class="edit-button-'+self.gridId +' fa fa-pencil-square-o fa-lg" title="Click to edit item" style="cursor: pointer"></i>',
							//click: (e) => { self.$emit("EditItem", e) }
						});}
						if (self.config.grid.delete) {commands.push({
							name: "Delete",
							template:'<i class="delete-button-'+self.gridId +' fa fa-trash fa-lg" title="Click to delete item" style="cursor: pointer"></i>',
							//click: (e) => { self.$emit("DeleteItem", e) }
						});}
						if (self.config.grid.erase) {commands.push({
							name: "Eraser",
							template:'<div class="erase-button-'+self.gridId +' fa-eraser-img" title="Click to erase item" style="cursor: pointer;margin-left: 15px;"></div>',
							// click: (e) => { self.$emit("AttachItem", e) }
						});}
						if (self.config.grid.document) {commands.push({
							name: "Attachment",
							template:'<i class="document-button fa fa-paperclip fa-lg" title="Click to show attachments" style="cursor: pointer"></i>',
							// click: (e) => { self.$emit("AttachItem", e) }
						});}
						if (self.config.grid.info) {commands.push({
							name: "Information",
							template:'<i class="info-button fa fa-info-circle fa-lg" title="Click to show information" style="cursor: pointer"></i>',
						});}
						if (self.config.grid.pdfdoc) {commands.push({
							name: "pdfdoc",
							template:'<i class="pdf-button-'+self.gridId +' fa fa-file-pdf-o fa-lg" title="Click to Download Report" style="cursor: pointer"></i>',
						});}

						// columns.unshift({ command: commands, title: "Actions", width: actionsColumnWidth });
						
						// if(self.config.grid.pdfdoc){
						// 	columns.push({ command: commands, title: "Statement Download", width: actionsColumnWidth });
						// } 

						if (self.config.grid.document) {
							columns.unshift({ command: commands, title: "Actions", width: actionsColumnWidth });
						}else if(self.config.grid.pdfdoc){
							columns.push({ command: commands, title: "Statement Download", width: actionsColumnWidth });
						} 
						else {
							columns.unshift({ command: commands, title: "Actions", width: actionsColumnWidth });
						}
					};
					break;					
			};

			if (self.config.grid.checkbox) {columns.unshift({ selectable: true, width: 35 });}
			return columns;
		},

		getKendoDataSource() { 
			// this function checks if any local data is passed through prop
			// if so, it generates an array of data out of the prop and makes sure all properties in the config JS file are added to the data (if not, Kendo will bug out)
			// if not, it uses function from mixin to call API to get data from the web server
			let self = this;
			
			let dataSource = {
				pageSize: self.pageSize,
				transport: {}
			};

			// default sorting
			if (self.config.grid && self.config.grid.sort) {dataSource.sort = self.config.grid.sort;}

			// Column Groupings
			if (self.group) {
				dataSource.group= self.group;
				dataSource.aggregate=self.aggregate;
			}

			// local data feed from the page
			if ( self.data ) {
				
				dataSource.transport.read = self.setLocalReadOptions;

				// incell batch editing
				if ( self.mode === "incell" ) {

					dataSource.batch = true;
					dataSource.schema = {
						model: self.setSchemaModel()
					};
					dataSource.transport.update = self.setLocalUpdateOptions;
					dataSource.transport.create = self.setLocalCreateOptions;
					dataSource.transport.destroy = self.setLocalDestroyOptions;

				}else if(self.mode === "inline"){
					dataSource.schema = {
						model: self.setSchemaModel()
					};
				}

			// api data feed
			} else {	
				// Get API data with Query replace with	this.setRemoteReadOptions;	
				// const filterData = self.withFilter(self.config.list, self.query) // initial page load
				dataSource.transport.read = function(options) { //this.setRemoteReadOptions;
					self.GetItems(self.config);
					//self.GetItems(self.config).then(res=>{console.log(res)});
					//console.log(self.config.list, self.query);
					const filterData = self.withFilter(self.config.list, self.query) // for grid refresh icon click
					options.success(filterData)
				} 

				// incell batch editing
				if ( self.mode === "incell" ) {

					dataSource.batch = true;
					dataSource.schema = {
						model: self.setSchemaModel()
					};
					dataSource.transport.update = self.setRemoteUpdateOptions;
					dataSource.transport.create = self.setRemoteCreateOptions;
					dataSource.transport.destroy = self.setRemoteDestroyOptions;

				}else if(self.mode === "actionedit"){
					dataSource.schema = {
						model: self.setSchemaModel()
					};
				}
			};

			return dataSource;
		},
		
		setSchemaModel() {
			let self = this;
			//TODO: bug out when extended config
			let schemaModel = {
				id: "Id",
				fields: _.zipObject( Object.keys(self.config.columns), Object.values(self.config.columns)
				.map(config => { return {type: config.type,editable:config.editable,validation:config.validation} }) )
			};

			// Object.entries(self.config.columns).forEach( (item) => {
			// 	if ( item[1].class === "id" ) {
			// 		schemaModel.id = item[0];
			// 	} else {
			// 		schemaModel.fields[item[0]] = { type: item[1].type };
			// 	};
			// });
			return schemaModel
		},

		setLocalReadOptions(options) {
			let self = this;
			options.success(self.data)
				// let dataAllProperties = [];

				// self.data.forEach( (item) => {

				// 	let dataItem = {}
				// 	// _.zipObject(Object.keys(self.config.columns), Object.values(resources));
				// 	Object.keys(self.config.columns)
				// 	.forEach( (key) => {
				// 		dataItem[key] = (item[key]) ? item[key] : null;
				// 	});

				// 	dataAllProperties.push(dataItem);
				// });

				// options.success(dataAllProperties)
		},

		setLocalUpdateOptions(options) {
			let self = this;
			options.data.models.forEach( (itemToBeUpdated) => {
				let i = self.data.findIndex( (oldItem) => {
					return oldItem["Id"] === itemToBeUpdated["Id"]
				});
				self.data[i] = itemToBeUpdated;
			})
			//console.log("update local data", self.data);
			options.success();
		},

		setLocalCreateOptions(options) {
			let self = this;
			options.data.models.forEach( (itemToBeAdded) => {
				if (itemToBeAdded["tempId"]) {
					let i = self.data.findIndex( (oldItem) => {
						return oldItem["tempId"] === itemToBeAdded["tempId"]
					});
					self.data[i] = itemToBeAdded;
				} else {
					itemToBeAdded["tempId"] = self._getGUID();
					self.data.push(itemToBeAdded);
				}
			});
			//console.log("create local data", self.data);
			options.success();
		},

		setLocalDestroyOptions(options) {
			let self = this;
			options.data.models.forEach( (itemToBeDeleted) => {
				if (itemToBeDeleted["tempId"]) {
					let i = self.data.findIndex( (oldItem) => {
						return oldItem["tempId"] === itemToBeDeleted["tempId"]
					});
					self.data.splice(i, 1);
				} else {
					let i = self.data.findIndex( (oldItem) => {
						return oldItem["Id"] === itemToBeDeleted["Id"]
					});
					self.data.splice(i, 1);
				}
			});
			//.log("delete local data", self.data);
			options.success();
		},

		setRemoteReadOptions: function(options) {
			let self = this;
			
			// self._getExtendedItems(self.config, self.query).then((response) => {
			// 	options.success(response)
			// });
		},

		setRemoteUpdateOptions() {
			let self = this;
		},

		setRemoteCreateOptions() {
			let self = this;
		},

		setRemoteDestroyOptions() {
			let self = this;
		},
		// getDropDownOptions: function(ddlSource){
		// 	//return "<select>"+ "<option>"+ this.ddlOptions +"</option>"+"</select>"
		// 	//ddlSource has the Source for the Drop Down List
		// 	//make Api calls to load the ddlOptions with the Options Array
		// 	var count=1;
		// 	var id=ddlSource+count;
		// 	var ddlOptions=this.dropdownOptions[ddlSource]

		// 	var start= "<select id='"+id+"'>"
		// 	var end="</select>"
			
		// 	ddlOptions.forEach(item=>{
		// 		//#= gender #
		// 		 var option="<option value="+item+">"+ item + "</option>"
		// 		 //var option="<option>#= this.Field #</option>"
		// 		 start=start+option
		// 	})
		// 	return start+end
		// },
		DropDownEditor(container, options) {
			//console.log(options)
                    $('<input  name="' + options.field + '"/>')
                        .appendTo(container)
                        .kendoDropDownList({
							id:options.field,
                            autoBind: true,
                            dataTextField: "Option",
                            dataValueField: "Option",
							dataSource: this.dropdownOptions[options.field]
       		});
		},
		percentEditor(container, options) {
			//console.log(options)
                    $('<input  name="' + options.field + '"/>')
                        .appendTo(container)
                        .kendoNumericTextBox({
							id:options.field,
							//value:options.field,
							decimals:4,
							factor:100,
							min:0.00,
							max:1.00,
							step:0.001			
       		});
		},
		dropdownActionMenu(uniqueField,menu){
			let startStr='<select '+ "rowId='#= "+uniqueField+" #'" + 'class="dropdownaction form-control" ><option value="">Select an action</option>'
			let finalStr='</select>'

			for (let menukey in menu[0]) {
				if (menu[0].hasOwnProperty(menukey)){
					let option="<option value="+menukey+">"+ menu[0][menukey] + "</option>"
				 	startStr=startStr+option
				}
					
			}

			return startStr + finalStr;
		},

		dataBound: function(e) {
			const self = this;
			// add custom class to status column for coloring
			if (self.colorizeColumn) {self._addClassToStatusColumn(e, self.gridId);}
			// add custom class to editable columns for coloring
			if (self.colorizeInputColumns && self.colorizeInputColumns.length > 0 ) {
				self.colorizeInputColumns.forEach((column) => {
					self._addClassToColumn(e, self.gridId, column, 'colorize-input')
				})
			}
			$('.dropdownaction').on('change',function(){
					//alert($(this).val() + " "+$(this).attr("rowid"));

					let option=$(this).val();
					let id=$(this).attr("rowid");
					$(this).val("")
					self.$emit("change",option,id);
					 //Emit events with the same name as the menu items 
					 //Get Hold of rows item
				// 	 console.log(e.container)
				// var grid = window.$("#DocumentManagerGrid").data("kendoGrid");
				// grid.select( $(e.currentTarget).closest("tr"));
				// var dataItem=$("#DocumentManagerGrid").data("kendoGrid").dataItem($(e.container).closest("tr"))
                // //var dataItem = gview.dataItem(window.$(e.currentTarget).closest("tr"));
				// 	 console.log(dataItem)
					 //$(this).val("")
			 });
			}
	}
};

</script>
<style>
.fa-trash
{
	margin-left: 20px !important;
}
.document-button
{
	margin-left: 20px;
}
.info-button
{
	margin-left: 20px;
}
#DocumentManagerGrid .k-grid-content .grid td.gridcell select {}
.dropdownaction.form-control{
	font-size:.97em;
}
</style>
